module.exports = __webpack_public_path__ + "static/media/CMA-CGM.0e3904a5.svg";